import { createApi } from '@reduxjs/toolkit/query/react'

export const rootApi = createApi({
    reducerPath: 'api',
    baseQuery: async () => ({ data: {} }),
    tagTypes: [],
    endpoints: () => ({}),
})
